/**
 * Уникальный идентификатор устройства: 2 цифры модели + 5 цифр серийного номера.
 * Однозначные модели (3 — 3D, 6 — 3DM) должны дополняться ведущим нулём,
 * иначе сервер (int.Parse(deviceId[0..2])) получает модель 63/6X и падает.
 */
export const buildDeviceId = (model: number | undefined, serial: string | undefined): string => {
    if (model == null || serial == null)
        return "";
    return String(model).padStart(2, "0") + String(serial).padStart(5, "0");
};
